import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TablePagination from "@/components/table/pagination";
import { pendingShipments } from "@/data/pending-shipments";
import { pendingShipmentsColumns } from "./columns";
import Filters from "./filters";

export type ShipmentTableDataType = (typeof pendingShipments)[number];

export default function ShipmentTable() {
    const { table, setData } = useTanStackTable<ShipmentTableDataType>({
        tableData: pendingShipments,
        columnConfig: pendingShipmentsColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 10,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
            },
            enableColumnResizing: false,
        },
    });

    return (
        <>
            <Filters table={table} />
            <Table table={table} variant="modern" />
            <TablePagination table={table} className="p-4" />
        </>
    );
}
